const UIkit = window.UIkit;

export default function () {
    document.addEventListener("DOMContentLoaded", function () {
        const wrapper = document.querySelector('.product-details .product-short-description-wrapper');
        const readMoreShow = document.querySelector('.product-details .read-more a.show');

        if (!wrapper || !readMoreShow) return;

        function handleShortDescription() {
            const div = wrapper.querySelector('.product-short-description');
            const readMoreHide = document.querySelector('.product-details .read-more a.hide');
            readMoreShow.classList.add('hidden');
            readMoreHide.classList.add('hidden');
            wrapper.classList.add('collapsed');
            if (!div) return;

            if (div.clientHeight >= 200) {
                readMoreShow.classList.remove('hidden');
            } else {
                wrapper.classList.remove('collapsed');
            }
        }

        handleShortDescription();

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList' || mutation.type === 'subtree') {
                    clearTimeout(window.__descTimer);
                    window.__descTimer = setTimeout(handleShortDescription, 50);
                    break;
                }
            }
        });

        observer.observe(wrapper, {
            childList: true,
            subtree: true,
        });
    });

    UIkit.util.on(document, 'click', '.product-details .product-short-description + .read-more a.show', function (e) {
        const wrapper = document.querySelector('.product-details .product-short-description-wrapper');
        const readMoreShow = document.querySelector('.product-details .product-short-description + .read-more a.show');
        const readMoreHide = document.querySelector('.product-details .product-short-description + .read-more a.hide');

        wrapper.classList.remove('collapsed');
        readMoreShow.classList.add('hidden');
        readMoreHide.classList.remove('hidden');

        e.preventDefault();
    });

    UIkit.util.on(document, 'click', '.product-details .product-short-description + .read-more a.hide', function (e) {
        const wrapper = document.querySelector('.product-details .product-short-description-wrapper');
        const readMoreShow = document.querySelector('.product-details .product-short-description + .read-more a.show');
        const readMoreHide = document.querySelector('.product-details .product-short-description + .read-more a.hide');

        wrapper.classList.add('collapsed');
        readMoreShow.classList.remove('hidden');
        readMoreHide.classList.add('hidden');

        e.preventDefault();
    });
}